import { render, staticRenderFns } from "./MyNotes.vue?vue&type=template&id=63b9c95f&"
import script from "./MyNotes.vue?vue&type=script&lang=js&"
export * from "./MyNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports